import { supabase } from '../lib/supabase';
import type { WebsiteMediaEntry, WebsiteMediaPlacementKey } from '@pigeons/shared-website-media';

export type website_media_upsert_payload = {
  placement_key: WebsiteMediaPlacementKey;
  image_url?: string | null;
  alt_text_fr?: string | null;
  alt_text_en?: string | null;
};

export const websiteMediaRepository = {
  async listEntries(): Promise<WebsiteMediaEntry[]> {
    const { data, error } = await supabase
      .from('website_media_entries')
      .select('*')
      .order('placement_key');

    if (error) {
      throw error;
    }

    return (data ?? []) as WebsiteMediaEntry[];
  },

  async upsertEntry(payload: website_media_upsert_payload): Promise<WebsiteMediaEntry> {
    const { data, error } = await supabase
      .from('website_media_entries')
      .upsert(payload, {
        onConflict: 'placement_key',
      })
      .select('*')
      .single();

    if (error) {
      throw error;
    }

    return data as WebsiteMediaEntry;
  },

  async deleteEntry(placementKey: WebsiteMediaPlacementKey): Promise<void> {
    const { error } = await supabase
      .from('website_media_entries')
      .delete()
      .eq('placement_key', placementKey);

    if (error) {
      throw error;
    }
  },
};
